import { Injectable } from "@angular/core";
import { Subject, Observable, Subscription, fromEvent } from "rxjs";
import { WorkerMessage } from "./models/worker-message.model";

@Injectable()
export class WorkerService {
  workerUpdate$?: Observable<WorkerMessage>;
  private worker?: Worker;
  private workerSubject?: Subject<WorkerMessage>;
  private workerMessageSubscription?: Subscription;

  public doWork(workerMessage: WorkerMessage): void {
    //console.log('workerMessage', workerMessage);
    if (this.worker) {
      // console.log('[Worker] Posting message:', workerMessage);
      this.worker.postMessage(workerMessage);
    } else {
      console.error("Worker could not be initialized.");
    }
  }

  public workerInit(): void {
    try {
      if (!!this.worker === false) {
        this.worker = new Worker(
          new URL("../../main.worker.ts", import.meta.url),
          { type: "module" },
        );
        this.workerSubject = new Subject<WorkerMessage>();
        this.workerUpdate$ = this.workerSubject.asObservable();
        // console.log('STARTING WORKER');

        this.workerMessageSubscription = fromEvent(
          this.worker,
          "message",
        ).subscribe({
          next: (response) => {
            const message = response as MessageEvent;

            if (this.workerSubject) {
              this.workerSubject.next(WorkerMessage.getInstance(message.data));
            }
          },
          error: (error) => console.error("WORKER ERROR::", error),
        });
      }
    } catch (exception) {
      console.error(exception);
    }
  }

  public close(): void {
    this.worker?.terminate();
    this.worker = undefined;
    this.workerSubject?.unsubscribe();
    this.workerMessageSubscription?.unsubscribe();
  }
}
